import { render, staticRenderFns } from "./MeshFramePage.vue?vue&type=template&id=6e4d791c"
import script from "./MeshFramePage.vue?vue&type=script&lang=js"
export * from "./MeshFramePage.vue?vue&type=script&lang=js"
import style0 from "./MeshFramePage.vue?vue&type=style&index=0&id=6e4d791c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports